module.exports = __webpack_public_path__ + "static/media/JosephP.6189a609.jpeg";